export default class JobsTransformation {
  static queryParams(data) {
    const { page, limit } = data;
    return {
      PageNumber: page,
      Take: limit,
    };
  }

  static jobDescription(jobDescription) {
    return {
      ...jobDescription,
      city: { title: jobDescription?.city?.name, id: jobDescription?.city?.id },
      team: { title: jobDescription?.department?.name, id: jobDescription?.department?.id },
      responsibility: jobDescription?.description,
      locale: jobDescription?.languageId >= 2 ? 'EN' : 'FA',
      submitUrl: jobDescription?.applicationFormRedirectUrl,
    };
  }

  static jobList(listOfJobs = []) {
    return listOfJobs.map((job) => ({
      ...job,
      city: { title: job.city?.cityTitleFa, id: job.city?.id },
      team: { title: job.department?.departmentTitle, id: job.department?.id },
    }));
  }
}
